import { useTheme } from '@mui/material';
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
// import { NumberFormat } from "react-number-format";

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        });
      }}
      thousandSeparator
      suffix="%"
      // isNumericString
    />
  );
}
// backspace starts the editor on Windows
const KEY_BACKSPACE = 'Backspace';
const KEY_ENTER = 'Enter';
const KEY_TAB = 'Tab';

export default forwardRef((props, ref) => {

  const createInitialState = () => {
    let startValue;

    if (props.eventKey === KEY_BACKSPACE) {
      // if backspace or delete pressed, we clear the cell
      startValue = '';
    } else if (props.charPress) {
      // if a letter was pressed, we start with the letter
      startValue = props.charPress;
    } else {
      // otherwise we start with the current value
      startValue = props.value;
    }

    return {
      value: startValue,
    };
  };

  const initialState = createInitialState();
  const [value, setValue] = useState(initialState.value);
  const refInput = useRef(null);
  const theme =useTheme();

  // focus on the input
  useEffect(() => {
    // get ref from React component
    window.setTimeout(() => {
      const eInput = refInput.current;
      eInput.focus();
    });
  }, []);

  /* Utility Methods */
  const cancelBeforeStart =
    props.charPress && '1234567890'.indexOf(props.charPress) < 0;

  const isLeftOrRight = (event) => {
    return ['ArrowLeft', 'ArrowRight'].indexOf(event.key) > -1;
  };
  function isCharDecimal(charStr) {
    return '.'.indexOf(charStr) === 0;
  }
  const isCharNumeric = (charStr) => {
    return !!/\d/.test(charStr);
  };

  const isKeyPressedNumeric = (event) => {
    const charStr = event.key;
    return isCharNumeric(charStr) || isCharDecimal(charStr);
  };

  const isBackspace = (event) => {
    return event.key === KEY_BACKSPACE;
  };

  const finishedEditingPressed = (event) => {
    const key = event.key;
    return key === KEY_ENTER || key === KEY_TAB;
  };

  const onKeyDown = (event) => {
    if (isLeftOrRight(event) || isBackspace(event)) {
      event.stopPropagation();
      return;
    }

    if (!finishedEditingPressed(event) && !isKeyPressedNumeric(event)) {
      if (event.preventDefault) event.preventDefault();
    }
  };

  /* Component Editor Lifecycle methods */
  useImperativeHandle(ref, () => {
    return {
      // the final value to send to the grid, on completion of editing
      getValue() {

        return value;
      },

      // Gets called once before editing starts, to give editor a chance to
      // cancel the editing before it even starts.
      isCancelBeforeStart() {
        return cancelBeforeStart;
      },

      // Gets called once when editing is finished (eg if Enter is pressed).
      // If you return true, then the result of the edit will be ignored.
      isCancelAfterEnd() {
        // will reject the number if it greater than 1,000,000
        // not very practical, but demonstrates the method.
        return value > 1000000;
      },
      focusIn() {
        var eInput = refInput.current;
        eInput.focus();
        eInput.select();
      },
  
    };
  });

  const handleOnChange = (event) => {
    setValue(event.target.value === '0' ? "0" : event.target.value === '' ? '' : event.target.value)
    const currentVal = event.target.value === '0' ? "0" : event.target.value === '' ? '' : Number(event.target.value)
    const rowData = props.node;
    rowData.setDataValue(props.column.colId, currentVal)


    if (props.column.colId === 'wg1CustStdDiscount' || props.column.colId === 'wg1CustSpclDiscount' || props.column.colId === 'wg1PromoDiscount') {
      const custWg1Std = props.column.colId === 'wg1CustStdDiscount' ? event.target.value : rowData.data.wg1CustStdDiscount
      const custWg1Spcl = props.column.colId === 'wg1CustSpclDiscount' ? event.target.value : rowData.data.wg1CustSpclDiscount
      const custWg1Promo = props.column.colId === 'wg1PromoDiscount' ? event.target.value : rowData.data.wg1PromoDiscount
      let total = Number(100 - (((100 - Number(custWg1Std)) * (100 - Number(custWg1Spcl))) / 100)).toFixed(2);
      if (custWg1Promo) {
        total = Number(100 - (((((100 - Number(custWg1Std)) * (100 - Number(custWg1Spcl))) / 100) * (100 - Number(custWg1Promo))) / 100)).toFixed(2);
      }
      rowData.setDataValue('wg1CustCumulativeDiscount', Number(total))
    } else if (props.column.colId === 'wg2CustStdDiscount' || props.column.colId === 'wg2CustSpclDiscount' || props.column.colId === 'wg2PromoDiscount') {
      const custWg2Std = props.column.colId === 'wg2CustStdDiscount' ? event.target.value : rowData.data.wg2CustStdDiscount
      const custWg2Spcl = props.column.colId === 'wg2CustSpclDiscount' ? event.target.value : rowData.data.wg2CustSpclDiscount
      const custWg2Promo = props.column.colId === 'wg2PromoDiscount' ? event.target.value : rowData.data.wg2PromoDiscount
      let total = Number(100 - (((100 - Number(custWg2Std)) * (100 - Number(custWg2Spcl))) / 100)).toFixed(2);
      if (custWg2Promo) {
        total = Number(100 - (((((100 - Number(custWg2Std)) * (100 - Number(custWg2Spcl))) / 100) * (100 - Number(custWg2Promo))) / 100)).toFixed(2);
      }
      rowData.setDataValue('wg2CustCumulativeDiscount', Number(total))
    } else if (props.column.colId === 'wg1VendorStdDiscount' || props.column.colId === 'wg1VendorSpclDiscount' || props.column.colId === 'wg1VendorPromoDiscount') {
      const vendWg1Std = props.column.colId === 'wg1VendorStdDiscount' ? event.target.value : rowData.data.wg1VendorStdDiscount
      const vendWg1Spcl = props.column.colId === 'wg1VendorSpclDiscount' ? event.target.value : rowData.data.wg1VendorSpclDiscount
      const vendWg1Promo = props.column.colId === 'wg1VendorPromoDiscount' ? event.target.value : rowData.data.wg1VendorPromoDiscount
      let total = Number(100 - (((100 - Number(vendWg1Std)) * (100 - Number(vendWg1Spcl))) / 100)).toFixed(2);
      if (vendWg1Promo) {
        total = Number(100 - (((((100 - Number(vendWg1Std)) * (100 - Number(vendWg1Spcl))) / 100) * (100 - Number(vendWg1Promo))) / 100)).toFixed(2);
      }
      rowData.setDataValue('wg1VendorCumulativeDiscount', Number(total))
    } else if (props.column.colId === 'wg2VendorStdDiscount' || props.column.colId === 'wg2VendorSpclDiscount' || props.column.colId === 'wg2VendorPromoDiscount') {
      const vendWg2Std = props.column.colId === 'wg2VendorStdDiscount' ? event.target.value : rowData.data.wg2VendorStdDiscount
      const vendWg2Spcl = props.column.colId === 'wg2VendorSpclDiscount' ? event.target.value : rowData.data.wg2VendorSpclDiscount
      const vendWg2Promo = props.column.colId === 'wg2VendorPromoDiscount' ? event.target.value : rowData.data.wg2VendorPromoDiscount
      let total = Number(100 - (((100 - Number(vendWg2Std)) * (100 - Number(vendWg2Spcl))) / 100)).toFixed(2);
      if (vendWg2Promo) {
        total = Number(100 - (((((100 - Number(vendWg2Std)) * (100 - Number(vendWg2Spcl))) / 100) * (100 - Number(vendWg2Promo))) / 100)).toFixed(2);
      }
      rowData.setDataValue('wg2VendorCumulativeDiscount', Number(total))
    }
  }

  return (
    <input
      ref={refInput}
      className={'simple-input-editor'}
      value={value}
      style={{ border: !value && '1px solid red ',backgroundColor: theme.palette.background.paper,color: theme.palette.text.primary}}
      onChange={handleOnChange}
      onKeyDown={(event) => onKeyDown(event)}
    />
  );
});